import React, { useState, useEffect } from 'react';

import { Carousel, QuickFilterButton } from '@hpi-sox/hpstellar-core';
import { buildFilterFromUrl, buildUrlFromFilters, removeFromFilter, facetInList } from '../util';

/**
 *
 * @param {*} filters - active filters object, ex {segm: {Home: "Home"}}
 * @param {*} href - the href for the current quick filter
 * @param {*} include - Array of filters to includes, ex ["segm=Home", "segm=Business"]
 * @param {*} exclude - Array of filters to exclude, ex ["segm=Home", "segm=Business"]
 * @returns
 */
const hideFilter = (filters, href, include, exclude) => {
    let newHref;
    const { included: isIncluded, matches } = facetInList(include, filters);
    const { included: isExcluded, matches: exlusionMatch } = facetInList(exclude, filters);
    const wildCardExclusion = Array.isArray(exclude) && (exclude?.length === 0 || exclude.includes('*'));
    if (isIncluded && Object.keys(matches).length > 0) {
        newHref = buildUrlFromFilters({ ...buildFilterFromUrl(href), ...matches });
    }

    // hide if it contains an explicit exclusion or if it is not included and the exclusion is not a wildcard
    return { hide: isExcluded || (!isIncluded && (wildCardExclusion || isExcluded)), newHref, exlusionMatch };
};

export default ({ quickFilters, quickFilterActive, setQuickFilter, isMobile, quickFilterTitle, entryFilter }) => {
    const [inpActive, setInpActive] = useState(null);

    useEffect(() => {
        if (typeof inpActive === 'number') {
            setInpActive(null);
        }
    }, [quickFilterActive]);

    const getOnClick = (href, i, restoreFilter) => () => {
        setInpActive([inpActive, quickFilterActive].includes(i) ? -1 : i);
        setTimeout(() => {
            setQuickFilter(href, i, restoreFilter);
        }, 0);
    };

    const derivedActive = typeof inpActive === 'number' ? inpActive : quickFilterActive;

    const settings = {
        arrows: false,
        dots: true,
        infinite: false,
        variableWidth: true,
    };
    const comp =
        Array.isArray(quickFilters) &&
        quickFilters.map((f, i) => {
            let isActive = i === derivedActive;
            const { href, include, exclude } = f || {};
            const { hide, newHref, exlusionMatch } = hideFilter(
                buildFilterFromUrl(entryFilter),
                href,
                include,
                exclude,
            );
            if (hide) {
                return null;
            }
            const restorFilter =
                isActive && newHref
                    ? removeFromFilter(buildFilterFromUrl(entryFilter), buildFilterFromUrl(f.href))
                    : undefined;
            return (
                f && (
                    <QuickFilterButton
                        key={`${f.label}-${i}`}
                        className={`quickFilter${i === 0 ? ' quickFilterFirst' : ''}`}
                        onClick={getOnClick(newHref || f.href, i, restorFilter)}
                        isActive={isActive}
                        gtmActions={f && f.gtmActions}
                        data-gtm-checked={!isActive}
                        data-filter={JSON.stringify(f)}
                        data-excluded={JSON.stringify(exlusionMatch)}
                    >
                        <h4>{f.label}</h4>
                    </QuickFilterButton>
                )
            );
        });

    if (!comp || comp.length === 0) {
        return null;
    }

    return isMobile ? (
        <Carousel className="filterCarousel" style={{ maxWidth: '100vw' }} {...settings}>
            {comp}
        </Carousel>
    ) : (
        <div className="quick-filter-container ">
            {quickFilterTitle}
            {comp}
        </div>
    );
};
